export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-problem-1.39508e57.png";